import { Outlet } from "react-router-dom";

const Plataformas = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default Plataformas;
